"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubCombienTempsRealisezInvestissementsTrads = void 0;
exports.ESubCombienTempsRealisezInvestissementsTrads = {
    between_10_15_ans: "Entre 10 et 15 ans",
    between_5_10_ans: "Entre 5 et 10 ans",
    greater_15_ans: "Supérieur à 15 ans",
    less_5_ans: "Inférieur à 5 ans",
};
